import React, { useEffect, useReducer, useState } from "react";
import { Form, Toast, ToastContainer, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { axiosOpen } from "../../../api/axios";
import "./AddUser.css";
const reducer = (state, action) => {
  switch (action.type) {
    case "firstName":
      return { ...state, firstName: action.payload };
    case "lastName":
      return { ...state, lastName: action.payload };
    case "username":
      return { ...state, userName: action.payload };
    case "password":
      return { ...state, password: action.payload };
    case "branch":
      return { ...state, branch: action.payload };
    case "email":
      return { ...state, email: action.payload };
  }
};

const AddUser = () => {
  const navigate = useNavigate();
  const [error, setError] = useState({
    isValid: true,
    firstName: "",
    lastName: "",
    userName: "",
    password: "",
    branch: "",
    email: "",
  });
  const [state, dispatch] = useReducer(reducer, {
    firstName: "",
    lastName: "",
    userName: "",
    password: "",
    branch: "",
    email: "",
  });
  const handleCloseForm = () => {
    navigate("/users")
  }
  const fieldsValidation = (state) => {
    let invalidForm = false;
    if (!state.firstName) {
      setError((err) => ({ ...err, firstName: "Field Required" }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, firstName: "" }));
      invalidForm = false;
    }
    if (!state.lastName) {
      setError((err) => ({ ...err, lastName: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, lastName: "" }));
      invalidForm = false;
    }
    /*if (!state.userName) {
      setError((err) => ({ ...err, userName: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, userName: "" }));
      invalidForm = false;
    }*/
    if (!state.password) {
      setError((err) => ({ ...err, password: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, password: "" }));
      invalidForm = false;
    }
    /*if (!state.branch) {
      setError((err) => ({ ...err, branch: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, branch: "" }));
      invalidForm = false;
    }*/
    if (!state.email) {
      setError((err) => ({ ...err, email: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, email: "" }));
      invalidForm = false;
    }
    return invalidForm;
  };

  const handleResetForm = () => {
    dispatch({ type: "firstName", payload: "" });
    dispatch({ type: "lastName", payload: "" });
    dispatch({ type: "username", payload: "" });
    dispatch({ type: "password", payload: "" });
    dispatch({ type: "branch", payload: "" });
    dispatch({ type: "email", payload: "" });
  };

  const handleAddUser = (e) => {
    e.preventDefault();
    if (fieldsValidation(state)) {
      return;
    } else {
      const requestBody = {
        fname: state.firstName,
        lname: state.lastName,
        username: state.email,
        password: state.password,
        branch: state.branch,
        email: state.email,
        status: "active",
        role: "user",
        companyId: localStorage.getItem("compId")
      };
      (async () => {
        try {
          await axiosOpen.post("api/add/admin", { ...requestBody });
          navigate("/users");
        } catch (err) {
          console.log(err);
        }
      })();
    }
  };

  return (
    <div className="add-user-container">
      <Form onSubmit={handleAddUser} className="add-user-form">
        <span className="close" onClick={handleCloseForm}>
         X
        </span>
        <Form.Group className="mb-3" controlId="formBasicFirstName">

          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="First Name"
            onChange={(e) => dispatch({ type: "firstName", payload: e.target.value })}
            isInvalid={error.firstName}
            value={state.firstName}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicLastName">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Last Name"
            onChange={(e) => dispatch({ type: "lastName", payload: e.target.value })}
            isInvalid={!!error.lastName}
            value={state.lastName}
          />
        </Form.Group>
        {/* <Form.Group  style={{display : "none"}} className="mb-3" controlId="formBasicUsername">
          <div>
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            placeholder="Username"
            onChange={(e) => dispatch({ type: "username", payload: e.target.value })}
            isInvalid={!!error.userName}
            value={state.userName}
          />
          </div>
        </Form.Group> */}
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            onChange={(e) => dispatch({ type: "password", payload: e.target.value })}
            isInvalid={!!error.password}
            value={state.password}
          />
        </Form.Group>
        {/* <Form.Group className="mb-3"  style={{display : "none"}} controlId="formBasicBranch">
          <Form.Label>Branch</Form.Label>
          <Form.Control
            type="text"
            placeholder="Branch"
            onChange={(e) => dispatch({ type: "branch", payload: e.target.value })}
            isInvalid={!!error.branch}
            value={state.branch}
          />
        </Form.Group> */}
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email"
            onChange={(e) => dispatch({ type: "email", payload: e.target.value })}
            isInvalid={!!error.email}
            value={state.email}
          />
        </Form.Group>
        <Button variant="primary" type="submit">
          Submit
        </Button>
        <Button variant="secondary" onClick={handleResetForm}>
          Reset
        </Button>
      </Form>
    </div>
  );
};

export default AddUser;
